// Normalizes an axios error's response into a plain string, safe to render
// directly in JSX/toasts. FastAPI/pydantic can return `detail` as a string,
// a 422 validation array, or a structured object — none of which are valid
// React children on their own.
export function errorMessage(e, fallback = 'Something went wrong') {
  const detail = e?.response?.data?.detail;

  if (typeof detail === 'string') return detail;

  if (Array.isArray(detail)) {
    const items = detail
      .map((item) => {
        const loc = Array.isArray(item?.loc) ? item.loc : [];
        const lastSegment = [...loc].reverse().find((seg) => seg !== 'body');
        const msg = item?.msg;
        if (lastSegment != null && msg) return `${lastSegment}: ${msg}`;
        return msg || null;
      })
      .filter(Boolean);
    return items.length ? items.join('; ') : fallback;
  }

  if (detail && typeof detail === 'object' && detail.message) {
    return detail.code ? `${detail.message} (${detail.code})` : detail.message;
  }

  return e?.message || fallback;
}

// Ticket 315: a suspended workspace's shared links answer 403 `tenant_suspended`.
// Whoever holds the link (borrower, partner, attorney) is not the workspace, so
// they get their own words instead of the sign-in message.
export const LINK_PAUSED_COPY = 'This link is paused. Contact your loan officer.';

// Ticket 329: the same 403 on a public slug page (site, lead form, RE page) reads as a page.
export const PAGE_PAUSED_COPY = 'This page is paused.';

export function isLinkPaused(e) {
  const d = e?.response?.status === 403 ? e?.response?.data?.detail : null;
  return !!d && d.code === 'tenant_suspended';
}

export function publicLinkError(e, fallback) {
  return isLinkPaused(e) ? LINK_PAUSED_COPY : errorMessage(e, fallback);
}
